export default function ObbyTowerIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="4" width="56" height="56" rx="12" fill="#5aa8ff" />
      <rect x="14" y="48" width="36" height="8" rx="2" fill="#3ddc84" />
      <rect x="30" y="38" width="18" height="6" rx="2" fill="#ffcc33" />
      <rect x="12" y="28" width="16" height="6" rx="2" fill="#c86bff" />
      <rect x="32" y="18" width="20" height="6" rx="2" fill="#ff8a1f" />
      <rect x="28" y="32" width="20" height="4" rx="1" fill="#ff2d4b" />
      <rect x="20" y="9" width="24" height="5" rx="2" fill="#ff5e5e" />
      <rect x="26" y="6" width="12" height="3" fill="#ffd34d" />
      <path d="M14 18 L15 12 L18.5 15.5 Z M26 18 L25 12 L21.5 15.5 Z" fill="#ff7a59" />
      <circle cx="20" cy="18.5" r="6" fill="#ff7a59" />
      <circle cx="20.5" cy="19" r="4.2" fill="#ffcfa8" />
      <circle cx="19" cy="18.5" r="0.9" fill="#222" />
      <circle cx="22" cy="18.5" r="0.9" fill="#222" />
      <rect x="15" y="23" width="10" height="6" rx="3" fill="#ff7a59" />
    </svg>
  );
}
